import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaonotafiscaldescargas(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaonotafiscaldescargas/FIND_NOTAFISCALDESCARGAS':
      case '@operacaonotafiscaldescargas/UPDATE_NOTAFISCALDESCARGAS':
      case '@operacaonotafiscaldescargas/DELETE_NOTAFISCALDESCARGAS':
      case '@operacaonotafiscaldescargas/STORE_NOTAFISCALDESCARGAS':
      case '@operacaonotafiscaldescargas/NOTAFISCALDESCARGAS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaonotafiscaldescargas/SUCCESS_REMOVE':
      case '@operacaonotafiscaldescargas/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaonotafiscaldescargas/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaonotafiscaldescargas;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaonotafiscaldescargas/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaonotafiscaldescargas;
        break;
      }

      case '@operacaonotafiscaldescargas/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
